import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { accountId: Number }

  async disconnect() {
    if (!confirm('Are you sure you want to disconnect this account? This will stop syncing transactions.')) {
      return
    }

    const button = this.element
    const originalText = button.textContent
    
    try {
      button.textContent = 'Disconnecting...'
      button.disabled = true
      
      const response = await fetch(`/api/v1/stripe_financial_connections/disconnect_account/${this.accountIdValue}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      const result = await response.json()
      
      if (result.success) {
        this.showSuccess(result.message)
        // Remove the account from the display
        this.element.closest('.bg-white').remove()
      } else {
        this.showError('Failed to disconnect account')
      }
    } catch (error) {
      console.error('Error disconnecting account:', error)
      this.showError('Failed to disconnect account')
    } finally {
      button.textContent = originalText
      button.disabled = false
    }
  }

  showError(message) {
    alert(`Error: ${message}`)
  }

  showSuccess(message) {
    alert(`Success: ${message}`)
  }
}